export const listTasksGroupByQuarterService = (fetch) => async (filters) => {
  try {
    const searchParams = new URLSearchParams(filters).toString();
    const response = await fetch({
      url: "/api/v1/plan-trabajo-capacitacion/agrupado-por-trimestre?" + searchParams,
    });

    return response;
  } catch (error) {
    throw new Error(error.response?.data?.message || error.message);
  }
};
